import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Settings } from '../../core/settings';
import { User } from '..';
import { deserializeArray } from 'santee-dcts';
import { EmailPreferenceCategory } from './email';
import { map, publishLast, refCount } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class EmailPreferencesCategoriesStorage {

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings,
    ) { }

    public loadEmailPreferenceCategories(user: User): Observable<EmailPreferenceCategory[]> {
        return this.http
            .get<Object[]>(`${this.settings.getSpecificUserApiUrl(user)}/email-preferences/categories`)
            .pipe(
                map((response: Object[]) => deserializeArray(response, EmailPreferenceCategory)),
                publishLast(),
                refCount()
            );
    }
}